<script context="module">
  import { writable } from 'svelte/store'
  export const isApolloAuthorized = writable(false)
</script>

<script>
  import { onDestroy } from 'svelte'
  import { idToken, accessToken } from '@dopry/svelte-oidc'
  import { authLink } from '../api'

  const subAccessToken = accessToken.subscribe((value) => {
    const was = authLink.isAuthorized()
    authLink.setAuthorization(null, value)
    if (!was) {
      isApolloAuthorized.set(authLink.isAuthorized())
    }
  })

  const subIdToken = idToken.subscribe((value) => {
    const was = authLink.isAuthorized()
    authLink.setAuthorization(value, null)
    if (!was) {
      isApolloAuthorized.set(authLink.isAuthorized())
    }
  })

  onDestroy(() => {
    subAccessToken()
    subIdToken()
  })
</script>

<slot />
